import { Button, DesignV2Scope, MobilePage } from "../design-v2";
import "../features/onboarding/onboarding.css";
import "./bootstrap.css";

function Brand() {
  return (
    <div className="lz-onboarding-brand-header">
      <p className="font-lz-v2-display text-lg font-bold uppercase text-lz-v2-text-strong">
        Lyft <span className="text-lz-v2-action">Zone</span>
      </p>
    </div>
  );
}

// `onReturnToWorkout` (optional, Phase 8 §9.8): a way back to a locally
// recoverable workout while the backend is unreachable.
export default function BootstrapScreen({ status, presentation, onRetry, onReturnToWorkout = null }) {
  const unavailable = status === "unavailable";
  const showBrand = unavailable || presentation !== "hidden";
  const copy = presentation === "long"
    ? "Almost there. This can take a moment after a while away."
    : presentation === "short"
      ? "Getting things ready…"
      : null;

  return (
    <DesignV2Scope>
      <MobilePage contentClassName="lz-bootstrap-screen">
        {showBrand ? (
          <div className="lz-bootstrap-screen__content">
            <Brand />
            {unavailable ? (
              <>
                <p className="text-lz-v2-text-muted" role="alert">
                  We couldn&apos;t reach Lyft Zone.
                </p>
                <Button onClick={onRetry}>Try again</Button>
                {onReturnToWorkout ? (
                  <Button variant="secondary" onClick={onReturnToWorkout}>Return to workout</Button>
                ) : null}
              </>
            ) : (
              <>
                <span className="lz-bootstrap-screen__indicator" role="status" aria-label="Loading" />
                {copy ? <p className="text-lz-v2-text-muted">{copy}</p> : null}
              </>
            )}
          </div>
        ) : null}
      </MobilePage>
    </DesignV2Scope>
  );
}
